<template>
  <div>
    <!-- MODO NORMAL: só botão de “Executar” e filtros de data -->
    <div v-if="!printMode">
      <h6>Despesas Pagas – Por Data de Vencimento</h6><p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <label>Data Início:</label>
          <input type="date" v-model="dataInicioLocal" class="form-control" />
        </div>
        <div class="col-auto">
          <label>Data Fim:</label>
          <input type="date" v-model="dataFimLocal" class="form-control" />
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">Executar</button>
        </div>
      </div>
    </div>

    <!-- MODO PRINT: tabela com registros pagos + total -->
    <div v-else>
      <p class="text-center" style="font-size: 14px;">
        ( {{ globalUtils.formatarData(dataInicio) }} a {{ globalUtils.formatarData(dataFim) }} )
      </p>
      <p></p>

      <div v-if="loading">Carregando…</div>
      <div v-else-if="resultados.length">
        <table class="table table-striped mb-2">
          <thead>
            <tr>
              <th>REFIL</th>
              <th>DESCRIÇÃO</th>
              <th class="valor-cell">VALOR</th>
              <th class="text-center">FORMA DE PAGAMENTO</th>
              <th class="text-center">DATA VENCIMENTO</th>
              <th class="text-center">DATA PAGAMENTO</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, idx) in resultados"
              :key="item.data_pagamento + '-' + item.descricao + '-' + idx"
            >
              <td>{{ item.refil }}</td>
              <td>{{ item.descricao }}</td>
              <td class="valor-cell">{{ formatarMoeda(item.valor) }}</td>
              <td class="text-center">{{ item.forma_pagamento }}</td>
              <td class="text-center">{{ globalUtils.formatarData(item.data_vencimento) }}</td>
              <td class="text-center">{{ globalUtils.formatarData(item.data_pagamento) }}</td>
            </tr>
          </tbody>
          <!-- Rodapé com o total -->
          <tfoot>
            <tr>
              <td colspan="2"><strong>Total</strong></td>
              <td class="valor-cell text-right">
                <strong>{{ formatarMoeda(total) }}</strong>
              </td>
              <td colspan="3"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <p>Nenhuma despesa paga nesse período.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'


const props = defineProps({
  printMode:  { type: Boolean, default: false },
  dataInicio: String,
  dataFim:    String,
  printTitle: { type: String, default: 'Despesas Pagas por Vencimento' },
  subtitle:   { type: String, default: '' }
})

const router = useRouter()

// Estados “tela normal”
const dataInicioLocal = ref('')
const dataFimLocal    = ref('')

// Estados “modo print”
const loading     = ref(false)
const resultados  = ref([])
const total       = ref(0)

onMounted(async () => {
  if (!props.printMode) return
  if (!props.dataInicio || !props.dataFim) return

  loading.value = true
  try {
    const res = await axios.get(
      '/gestao/relatorios/despesas/despesas-pagas-por-vencimento',
      {
        params: {
          dataInicio: props.dataInicio,
          dataFim:    props.dataFim
        }
      }
    )
    // O back-end envia { items: [...], total: 123.45 }
    resultados.value = Array.isArray(res.data.items) ? res.data.items : []
    total.value       = parseFloat(res.data.total) || 0
  } catch (e) {
    console.error('Erro ao buscar despesas pagas por vencimento:', e)
    resultados.value = []
    total.value      = 0
  } finally {
    loading.value = false
  }
})

function abrirPrint() {
  if (!dataInicioLocal.value || !dataFimLocal.value) return

  const inicioFormatado = globalUtils.formatarData(dataInicioLocal.value)
  const fimFormatado    = globalUtils.formatarData(dataFimLocal.value)

  // 3) Montar o subtitle completo, incluindo período
  const subtitle = `( ${inicioFormatado} a ${fimFormatado} )`

  router.push({
    path: `/gestao/relatorios/print/despesas-pagas-por-vencimento`,
    query: {
      title:      'Despesas Pagas por Vencimento',
      dataInicio: dataInicioLocal.value,
      dataFim:    dataFimLocal.value,
      subtitle:   subtitle
    }
  })
}

function formatarMoeda(num) {
  if (num == null) return ''
  return Number(num).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.valor-cell {
  text-align: right !important;
}
.text-right {
  text-align: right !important;
}
</style>
